import React from 'react'
import { Link } from 'react-router-dom'
import PropTypes from 'prop-types'
import { default as dayjs } from 'dayjs'

import { vFAttendance } from '../../lib/fpFuncs'

import bioIco from '../../assets/images/biometric-icon.png'
import bioScan from '../../assets/images/fingerprint-scan.gif'
import bioDenied from '../../assets/images/biometric-denied-icon.png'
import bioAccept from '../../assets/images/biometric-accept-icon.png'

export const BioFPAttendance = ({
  modSchema,
  urlLink,
  isLocalEnvironment,
  fpList,
  createCallMutation,
}) => {
  const [fpError, setFPError] = React.useState(false)
  const [fpInit, setFPInit] = React.useState(false)
  const [fpSuccess, setFPSuccess] = React.useState(false)
  const [fpResponse, setFPResponse] = React.useState(null)
  const [attendanceType, setAttendanceType] = React.useState('students')
  const [disableCheckIn, setDisableCheckIn] = React.useState(false)
  const [dt, setDt] = React.useState(new Date().toLocaleString())
  React.useEffect(() => {
    let secTimer = setInterval(() => {
      setDt(dayjs().format('DD-MM-YYYY h:mm:ss A').toLocaleString())
    }, 1000)

    return () => clearInterval(secTimer)
  }, [])
  const list = fpList.state.dependeciesFormAPIS['attendance/attendance-details']
    ? fpList.state.dependeciesFormAPIS['attendance/attendance-details'].formData
    : null
  const resetFPForm = () => {
    setFPError(false)
    setFPResponse(null)
    if (document.getElementById('fpInput')) {
      document.getElementById('fpInput').value = ''
      document.getElementById('fpInput').focus()
    }
  }

  const valFP = async () => {
    setFPInit(true)
    await vFAttendance(
      setFPError,
      setFPResponse,
      list,
      isLocalEnvironment,
      modSchema.formAPI,
      '',
      modSchema.moduleName,
      attendanceType,
      createCallMutation,
      modSchema,
      setFPSuccess,
      setDisableCheckIn,
    )
    setFPInit(false)
  }

  return (
    <div key={modSchema.type} className="trtui-row trtui-justify-content-center">
      <div className="trtui-col-lg-8">
        <div className="trtui-card">
          <div className="trtui-card-body">
            <div className="trtui-text-center">
              <div className="trtui-row trtui-justify-content-center">
                <div className="trtui-col-lg-12">
                  <span className="trtui-cursor-pointer" onClick={() => setAttendanceType('staff')}>
                    Staff
                  </span>{' '}
                  |{' '}
                  <span
                    className="trtui-cursor-pointer"
                    onClick={() => setAttendanceType('students')}
                  >
                    Students
                  </span>
                </div>
                <div className="trtui-col-lg-12">
                  <h6 className="trtui-fw-semibold">
                    {attendanceType === 'staff' && (
                      <>
                        <Link
                          to={`/${urlLink.length && urlLink.length > 1 ? 'organization' : 'console'}/check-in`}
                        >
                          <button
                            type="button"
                            disabled={modSchema.type === 'CheckOut' ? false : true}
                            className="trtui-btn trtui-btn-primary trtui-mr-2"
                          >
                            Check In
                          </button>
                        </Link>{' '}
                        <Link
                          to={`/${urlLink.length && urlLink.length > 1 ? 'organization' : 'console'}/check-out`}
                        >
                          <button
                            type="button"
                            disabled={modSchema.type === 'CheckOut' ? true : false}
                            className="trtui-btn trtui-btn-primary trtui-ml-2"
                          >
                            Check Out
                          </button>
                        </Link>
                      </>
                    )}
                  </h6>
                  <h4 className="trtui-mt-2">
                    {attendanceType === 'staff' ? 'Staff Attendance' : 'Student Attendance'}{' '}
                    {/* {modSchema.type === 'CheckOut' ? 'Check-Out' : 'Check-In'} */}
                  </h4>
                  <div className="trtui-row trtui-justify-content-center">
                    <div className="trtui-col-lg-9">
                      {dt}
                      <p className="trtui-text-muted trtui-mt-3">
                        Click on below button and place your finger properly on the device.
                      </p>
                      {fpError !== true && fpResponse === null && fpSuccess !== true && (
                        <button
                          className="trtui-btn trtui-btn-primary"
                          id="fpInput"
                          type="button"
                          onClick={valFP}
                          disabled={disableCheckIn}
                        >
                          Biometric Attendance
                        </button>
                      )}
                    </div>
                  </div>
                  <div className="trtui-row trtui-justify-content-center trtui-mt-5 trtui-mb-2">
                    <div className="col-sm-7 col-8">
                      {fpError && (
                        <>
                          <img
                            src={bioDenied}
                            style={{ width: '30%' }}
                            alt=""
                            className="trtui-img-fluid"
                          />
                          <p className="trtui-mt-2 trtui-mb-2">Invalid biometric!</p>
                          <button
                            className="trtui-btn trtui-btn-danger"
                            onClick={() => resetFPForm()}
                          >
                            Try Again
                          </button>
                        </>
                      )}
                      {!fpError && fpResponse === 'success' && (
                        <>
                          <img
                            src={bioAccept}
                            style={{ width: '30%' }}
                            alt=""
                            className="trtui-img-fluid"
                          />
                          <p className="trtui-mt-2 trtui-mb-2">
                            {modSchema.moduleName === 'StaffCheckOut'
                              ? 'Check-Out Successfull!'
                              : 'Check-In Successfull'}
                            !
                          </p>
                          <button
                            className="trtui-btn trtui-btn-success"
                            onClick={() => resetFPForm()}
                          >
                            Done
                          </button>
                        </>
                      )}
                      {!fpInit && !fpError && !fpResponse && !disableCheckIn && (
                        <img
                          src={bioIco}
                          style={{ width: '30%' }}
                          alt=""
                          className="trtui-img-fluid"
                        />
                      )}
                      {fpInit && (
                        <img
                          src={bioScan}
                          style={{ width: '30%' }}
                          alt=""
                          className="trtui-img-fluid"
                        />
                      )}
                    </div>
                  </div>
                  <div className="trtui-card">
                    <div className="trtui-card-body">
                      <div className="trtui-text-center"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

BioFPAttendance.propTypes = {
  modSchema: PropTypes.object,
  urlLink: PropTypes.array,
  isLocalEnvironment: PropTypes.string,
  fpList: PropTypes.object,
  createCallMutation: PropTypes.object,
}
